<template>
<v-app>
  <v-main>
      <v-container fluid ma-0 pa-0 fill-height style="overflow: hidden">
        <v-layout row>
          <v-flex class="box" id="leftBackground" xs0 sm5 md7>
            
                  <img id="vacationImage" style="float: left; margin-top: 103px; margin-left: 67px" src="@/assets/i-vacation.png" />
              
          </v-flex>
          <v-flex id="rightForm" class="box" xs12 sm7 md5 px-md-10>
                <v-form ref="form" >
         <v-container id="formContainer">
            <v-col class="mt-20" cols="12" id="loginHeader">
               <h1>{{ $t("common_login") }}</h1>
            </v-col>
            <v-col cols="12">
               <v-text-field :placeholder='$t("login_email")' @blur="validateForm" @keyup.enter= "validateForm"  single-line append-icon="mdi-email-outline" v-model="$v.email.$model"></v-text-field>
            </v-col>
            <v-col cols="12">
             <v-text-field :placeholder='$t("login_password")' @blur="validateForm" @keyup.enter= "validateForm"  :type="'password'" single-line append-icon="mdi-lock-outline" v-model="$v.password.$model"></v-text-field>
            </v-col>
            <v-col cols="12" class="mb-10 mt-4">
              <div style="float: left">
                <div style="float:left" class="mr-2 pt-09"><input type="checkbox" id="checkbox" v-model="isRemember"></div>
                <div style="float:right" id="checkBox"><label for="checkbox">{{ $t("login_remember") }}<p></p></label></div>
              </div>
            </v-col>
            <v-col cols="12" class="mt-n6">
                <ul id="listMessage">
                  <li style="text-align: center" v-for="item in errors" :key="item">
                     {{ item}}
                  </li>
               </ul>
            </v-col>
            <v-col cols="12">
               <v-btn id="btnLogin" v-on:click="handleLogin">{{ $t("common_login") }}</v-btn>
            </v-col>
            <v-col cols="12">
              <div id="textCannotLogin">
                <div class="container">
                  <a style="color: grey" @click="moveToReset"><h4 style="opacity: 0.4; text-decoration: underline;"> {{ $t("login_forgot_password") }} </h4></a>
                </div>
              </div>
            </v-col>
            <v-col style="margin-top: -85px" cols="12" class="mb-16">
                <v-divider class="divider"></v-divider>
            </v-col>
            <v-col cols="12" id="LanguageCol">
              <SelectLanguages/>
            </v-col>
         </v-container>
        </v-form>
          </v-flex>
        </v-layout>
      </v-container>
  </v-main>
</v-app>
</template>

<script>
    import { mapMutations, mapGetters } from "vuex";
    import { required, email } from "vuelidate/lib/validators";
    import { ListEvents } from "@/utilities/CommonUtilities";
    import SelectLanguages from "./SelectLanguages";

    export default {
        components: {SelectLanguages},
        validations: {
          password: { required },
          email: { required, email }
        },
        data () {
            return {
                isRemember: false,
                email: "",
                password: "",
                apiErrorOccurred: null,
                label: this.$i18n.t('common_unknown_error'),
                errors:[],
            }
        },
        computed: {
            ...mapGetters(["credentialInfo"]),
            passwordErrors () {
              const errors = []
              if (!this.$v.password.$dirty) return errors
              !this.$v.password.required && errors.push( this.$i18n.t('login_password_empty_msg'))
              return errors
            },
            emailErrors () {
              const errors = []
              if (!this.$v.email.$dirty) return errors
              !this.$v.email.email && errors.push( this.$i18n.t('forgot_email_format_incorrect'))
              !this.$v.email.required && errors.push( this.$i18n.t('login_email_empty_msg'))
              return errors
            },
            errorList() {
              if(this.emailErrors.length > 0 || this.passwordErrors.length > 0) {
                return [...this.emailErrors, ...this.passwordErrors];
              } else if(this.apiErrorOccurred != null) {
                return [this.apiErrorOccurred];
              } else return [];
            }
        },
        watch:{
          email() {
            this.apiErrorOccurred = null;
          },
          password() {
            this.apiErrorOccurred = null;
          }
        },
        methods: {
            ...mapMutations({
                saveCredentialInfo: "saveCredentialInfo"
            }
            ),
             validateForm(){
               if(this.errorList.length > 0 || this.errorList.length > 0) {
                 this.errors = this.errorList
               }else{
                 this.errors = []
               }
             },
            async handleLogin() {
              this.$v.$touch()
              if (this.$v.$invalid) {
                 this.validateForm();
                return;
              }
                 this.notifyBus.$emit(ListEvents.showLoadingIndicator);
              let params = {
                  'email': this.email.toLowerCase(),
                  'password': this.password,
                  'device_token': '1'};
              try{
                let response = await this.dataSource.postData(this.dataSource.loginURL, params);
                let token = response.data['token'];
                let userInfo = response.data['user']
                this.saveCredentialInfo(
                  { userName: this.email,
                    password: this.password,
                    isWillSaveCredential: this.isRemember,
                    token: token,
                    userInfo: userInfo});
              }catch(ex) {
                this.notifyBus.$on("httpError", this.handleError);
                this.errors = this.errorList
                return;
              }finally {
                this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
              }

              this.$router.push({name: "home"});
              
            },
            handleError() {
                this.apiErrorOccurred = this.$i18n.t('common_unknown_error');
            },
            moveToReset() {
             this.$router.push('/reset');
            },
        },
        created() {
            this.email = this.credentialInfo.userName;
            this.password = this.credentialInfo.password;
            this.isRemember = this.credentialInfo.isWillSaveCredential;

            this.notifyBus.$on("httpError", this.handleError);
        },
        inject: ["dataSource", "notifyBus"],
    }
</script>
<style scoped>
#checkBox{
  margin-top: -0.51px
}
#myField{
  border-color: #6fbd44;
}
.divider {
  margin-top: 63px;
  margin-right: 10px;
  padding-bottom: 4px
}
hr.solid {
  border-top: 3px solid #bbb;
}
 #loginHeader{
  margin-top: 80px;
  text-align: start
 }
 h1{
  font-size: 40px
 }
 #rightForm{
  width: 100%;
  height: 100%;
  background-image: url('../../assets/background_login1.png');
  -webkit-background-size: contain;
  -moz-background-size: contain;
  -o-background-size: cover;
  background-size: cover;
 }
 #btnLogin{
  background-color: #f1bd42;
  width: 100%;
  height: 100%;
  font-size: 18px;
  color: white;
  height: 50px;
  font: bold;
  font-weight: 800;
  opacity: 1;
  padding-top: 15px;
  padding-bottom: 15px
 }
 #textCannotLogin{
  color: grey;
  font-size: 14px;
  text-decoration: underline
 }
hr.solid {
  border-top: 0.1px solid grey;
  margin-top: 100px
}
#leftBackground{
  background: url('../../assets/background_login2.png');
  -webkit-background-size: contain;
  -moz-background-size: contain;
  -o-background-size: contain;
  background-size:cover;
  margin-top: -15px;
  width: 100%;
}
a{
  padding:1em;
  text-align: center;
  display:inline-block;
  text-decoration: none !important;
  margin:0 auto;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
   transition: all 0.2s ease-in-out;
   color: grey;
}
#listMessage{
  list-style-type: none;
  width: 100%;
  margin: auto;
  color: red;
  text-align: center
}

.container{
  width: 100%;
  text-align: center;
}

li{
  size: 1px;
  text-align: center;
  white-space: nowrap;
}

@media screen and (max-width: 1500px) {
  #formContainer{ 
   padding: 30px;
}
}
@media screen and (max-width: 960px) {
  #vacationImage{ 
   height: 80px;
   width: 200px;
}
}
@media screen and (max-width: 600px) {
  #leftBackground{
    display: none
  }
}
#LanguageCol{
  margin-top: -100px
}
.v-application ul{
  padding-left: 0px
}
</style>
